import { WizTableForm } from '@/containers/common'
const columns = () => {
    return [
        {
            title: '阶段名称',
            name: 'name',
            dataIndex: 'name',
            searchItem: {},
            tableItem: {width: 120}
        },
        {
            title: '所属路径',
            name: 'trainPathName',
            dataIndex: 'trainPathName',
            tableItem: {width: 180}
        }, 
        {
            title: '阶段类型',
            name: 'type',
            dataIndex: 'type',
            searchItem: {type: 'select'},
            tableItem: {width: 80},
            dict: [
                {code: 0, codeName: '选修'},
                {code: 1, codeName: '必修'}
              ]
        },
        {
            title: '阶段学习方式',
            name: 'learningStyle',
            dataIndex: 'learningStyle',
            searchItem: {type: 'select'},
            tableItem: {width: 100},
            dict: [
                {code: 0, codeName: '自主学习'},
                {code: 1, codeName: '顺序学习'} 
              ]
        },
        {
            title: '学习人数',
            name: 'joinNum',
            dataIndex: 'joinNum',
            tableItem: {width: 80}
        }
    ]
}

const tableApi = (api = {}) => {
    return {
        path: 'trainPathStage/stageListPage',
        ...api
    }
};

const pathStageReport = (self, api) => {
    return {
        type: 'diy',
        initialValue: [],
        rowkey: 'id',
        columns: columns(),
        tableApi: tableApi(api),
    }
};

export default pathStageReport
